import { Injectable } from '@angular/core';
import { TokenAuthService } from './token-auth.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, Observable, switchMap } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContributionIncentiveProgramService {

  
  constructor(public tokenAuthService: TokenAuthService,
    private httpClient: HttpClient,
  ) { }

  private readonly incentive_programs_Url = `${environment.base_URL}${environment.contributorIncentiveProgram_URL}`;

    getIncentivePrograms(contributorId:any): Observable<any> {
    const url = `${this.incentive_programs_Url}/contributor/${contributorId}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.get<any[]>(url, { headers });
      }),
      catchError((error) => {
        console.error('Error fetching Incentive Programs:', error);
        throw error;
      })
    );
  }


  getIncentiveProgramById(id:any): Observable<any> {
    const url = `${this.incentive_programs_Url}/${id}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.get<any[]>(url, { headers });
      }),
      catchError((error) => {
        console.error('Error fetching Incentive Programs:', error);
        throw error;
      })
    );
  }


    updateIncentiveProgram(id:any,incentiveProgramDto:any): Observable<any> {
    const url = `${this.incentive_programs_Url}/${id}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.put<any>(url, incentiveProgramDto, { headers });
      }),
      catchError((error) => {
        console.error('Error fetching Incentive Programs:', error);
        throw error;
      })
    );
  }

  createIncentiveProgram(incentiveProgramDto:any): Observable<any> {
    const url = `${this.incentive_programs_Url}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.post<any>(url, incentiveProgramDto, { headers });
      }),
      catchError((error) => {
        console.error('Error fetching Incentive Programs:', error);
        throw error;
      })
    );
  }
   
   getPendingApprovals(userId:any): Observable<any> { 
     const url = `${this.incentive_programs_Url}/pending/contributor/${userId}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.get<any[]>(url, { headers });
      }),
      catchError((error) => {
        console.error('Error fetching Incentive Programs:', error);
        throw error;
      })
    );
  
  }


     getPendingApprovalList(): Observable<any> { 
     const url = `${this.incentive_programs_Url}/pending`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.get<any[]>(url, { headers });
      }),
      catchError((error) => {
        console.error('Error fetching Incentive Programs:', error);
        throw error;
      })
    );
  
  }

    getPendingApprovalsComaprisonById(id:any): Observable<any> { 
     const url = `${this.incentive_programs_Url}/pending/${id}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.get<any[]>(url, { headers });
      }),
      catchError((error) => {
        console.error('Error fetching Incentive Programs:', error);
        throw error;
      })
    );
  
  }

  rejectIncentiveProgramApprovalRequest(id:any): Observable<any> {
    const url = `${this.incentive_programs_Url}/reject/${id}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.post<any>(url, {}, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  
  
  }

  approveIncentiveProgramApprovalRequest(id: any): Observable<any> {
    const url = `${this.incentive_programs_Url}/approve/${id}`;
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
        return this.httpClient.post<any>(url, {}, { headers });
      }),
      catchError((error) => { throw error; })
    );
  }

  bulkApprove(ids: number[]): Observable<{ succeeded: number[]; failed: Record<string, string> }> {
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
        return this.httpClient.post<{ succeeded: number[]; failed: Record<string, string> }>(
          `${this.incentive_programs_Url}/approve`, ids, { headers }
        );
      }),
      catchError((error) => { throw error; })
    );
  }

  getIncentiveProgramsList(): Observable<any> {
    const url = `${this.incentive_programs_Url}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.get<any[]>(url, { headers });
      }),
      catchError((error) => {
        console.error('Error fetching Incentive Programs:', error);
        throw error;
      })
    );
  }

    deleteIncentiveProgram(id:any): Observable<any> {
    const url = `${this.incentive_programs_Url}/${id}`; 

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.delete<any>(url, { headers });
      }),
      catchError((error) => {
        console.error('Error deleting Incentive Program:', error);
        throw error;
      })
    );
  }


  
}